<template>
  <AppHeader>Pending Bottle Edit</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Creator Name</p>
        <input v-model="creator_name" class="w-full text-xl mt-2" type="text" disabled>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Owner Name</p>
        <input v-model="owner_name" class="w-full text-xl mt-2" type="text" disabled>
      </div>
      
      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Product</p>
        <select v-model="product_name" class="w-full text-xl mt-2 outline-none bg-white" name="" id="">
          <option value="">-- Select Product --</option>
          <option v-for="product in products" :key="product.id" :value="product.id">{{ product.name }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.product_id">{{ errors.product_id }}</p>
      </div>
      
      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Type</p>
        <select v-model="product_type" class="w-full text-xl mt-2 outline-none bg-white" name="" id="">
          <option value="">-- Select Type --</option>
          <option v-for="type in types" :key="type" :value="type">{{ type }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.type">{{ errors.type }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Quantity</p>
        <input v-model="product_quantity" class="w-full text-xl mt-2 outline-none bg-white" type="number" placeholder="Enter the quantity">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.quantity">{{ errors.quantity }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button @click="editBottleUpdate" class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300">Edit Entries</button>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';

export default {
  name: 'BottleExchangeEdit',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },

  data() {
    return {
      state: 'loading',
      products: [],
      creator_name: '',
      owner_name: '',
      product_name: '',
      product_type: '',
      product_quantity: '',
      types: ['Given', 'Taken', 'Breakage', 'Missing']
    }
  },

  methods: {
    getData() {
      this.state = 'loading';
      this.request('GET', 'customer-bottle-exchange/' + this.$route.query.id + '/update', null, (resp) => {
        this.state = 'idle';

        if (resp.success) {
          this.products = resp.data.subscription_products;
          this.creator_name = resp.data.entry.creator_name;
          this.owner_name = resp.data.entry.owner_name;
          this.product_name = resp.data.entry.product_id;
          this.product_type = resp.data.entry.type;
          this.product_quantity = resp.data.entry.quantity;
        }
      });
    },

    editBottleUpdate() {
      let rules = {
        product_id: 'required|numeric',
        type: 'required|notempty',
        quantity: 'required|numeric'
      };

      let data = {
        product_id: this.product_name,
        type: this.product_type,
        quantity: this.product_quantity
      };

      if (!this.validateForm(data, rules)) return;

      this.state = 'loading';
      this.request('POST', 'customer-bottle-exchange/' + this.$route.query.id + '/update', data, (resp) => {
        this.state = 'idle';

        alert(resp.message ? resp.message : 'Unable to process your request, try again!');

        if (resp.success) {
          this.$router.go(-1);
        }
      })
    }
  },

  created() {
    this.getData();
  },
}
</script>